import React from 'react';

import update from 'immutability-helper';
import {Globs, KEY} from '../../Globs';
import * as moment from 'moment';
import MicroEvent  from '../../other/microevent';
import TextView from '../../../elegant_form_validation/Util/TextView.js';
import { run, ruleRunner } from '../../../elegant_form_validation/Validation/ruleRunner.js'
import { required,minValue, maxValue, positiveInt, URL } from '../../../elegant_form_validation/Validation/rules.js';
import Obtainer from '../../helpers/Obtainer';
import Container from 'react-bootstrap/esm/Container.js';
import Row from 'react-bootstrap/esm/Row.js';
import Col from 'react-bootstrap/esm/Col.js';
import TimePicker from "../units/TimePicker";
import Checkbox from '../../ui/Checkbox';

// f.e. https://soundcloud.com/deephousezagreb
const fieldValidations = [
  ruleRunner("URL", "", required, URL),
  ruleRunner("follow_cnt", "", required, positiveInt, minValue(1), maxValue(99)),
  ruleRunner("unfollow_cnt", "", required, positiveInt, minValue(1), maxValue(300)),
];

export default class PanelOptions extends React.Component {


  singleObtainQueriesDone = {};
  id_waitForObtain = null;
  setOptionsDisabled(disabled){
    //console.log('zdis'+disabled);
    this.setState({disabled : disabled});
  }

  constructor(props) {
    super(props);

    MicroEvent.mixin(PanelOptions);
    this.bind('setOptionsDisabled');

    this.handleChange = this.handleChange.bind(this);
    this.handleFieldChanged = this.handleFieldChanged.bind(this);
    this.errorFor = this.errorFor.bind(this);
    this.onClick = this.onClick.bind(this);

    this.state = {
      follow                        : Globs.get(KEY.FOLLOW),
      unfollow                      : Globs.get(KEY.UNFOLLOW),
      unfollow_passive_1st          : Globs.get(KEY.UNFOLLOW_PASSIVE_1ST),
      cycle                         : Globs.get(KEY.CYCLIC),
      follow_pros_only              : Globs.get(KEY.FOLLOW_PROS_ONLY),
      whitelist_manual_followings   : Globs.get(KEY.WHITELIST_MANUAL_FOLLOWINGS),
      showErrors                    : true,
      validationErrors              : { },
      URL                           : Globs.get(KEY.URL),
      count                         : ''+Globs.get(KEY.COUNT),
      follow_cnt                    : ''+Globs.get(KEY.FOLLOW_CNT),
      unfollow_cnt                  : ''+Globs.get(KEY.UNFOLLOW_CNT),
      hh                            : Globs.get(KEY.HH),
      mm                            : Globs.get(KEY.MM),
      time_value                    : moment(),
      disabled                      : true
    }

    Obtainer.mixin(PanelOptions);

    //it must refresh
    //this.bindObtain(
    this.bindPeriodicalObtain(
      this.OBTAINS().ACCOUNT_SETS,
      null,
      (data)=>{
        var sts = data['process_status'];

        var isIdle = (sts==='failed' || sts==='succeeded' || sts==='cancelled' || sts==='undefined');

        this.setOptionsDisabled(!isIdle);

        //always set settings when server auto change it
        var setsWasChangedOnServer = Globs.get(KEY.ACCOUNT_SETS_SERVER_TS) != data['timestamp'];
        if ( setsWasChangedOnServer || (!isIdle || (isIdle && Globs.get(KEY.OPTIONS_UI_SET_TIME) < data['timestamp'])))
        {
          Globs.set(KEY.HH, data['hh']);
          Globs.set(KEY.MM, data['mm']);

          var m = moment();
          m.set({h: data['hh'], m: data['mm']});
          this.setState({time_value:m});


          var todo = data['todo'];
          Globs.set(KEY.COUNT, todo);
          this.setState({count:todo});
          //setting this immediately to enable running validation
          this.state.count = todo;
          //<-

          var cnt = data['follow_cnt'];
          Globs.set(KEY.FOLLOW_CNT, cnt);
          this.setState({follow_cnt:cnt});
          //setting this immediately to enable running validation
          this.state.follow_cnt = cnt;

          var cnt = data['unfollow_cnt'];
          Globs.set(KEY.UNFOLLOW_CNT, cnt);
          this.setState({unfollow_cnt:cnt});
          //setting this immediately to enable running validation
          this.state.unfollow_cnt = cnt;


          var url = data['url'];
          Globs.set(KEY.URL, url);
          this.setState({URL: url});
          //setting url also immediately to enable running validation
          this.state.URL = url;
          //<-

          Globs.set(KEY.FOLLOW_PROS_ONLY, data['pros_only']);
          this.setState({follow_pros_only:  Globs.get(KEY.FOLLOW_PROS_ONLY)});

          Globs.set(KEY.WHITELIST_MANUAL_FOLLOWINGS, data['whitelist_only']);
          this.setState({whitelist_manual_followings:  Globs.get(KEY.WHITELIST_MANUAL_FOLLOWINGS)});

          var ps_name = data['process'];

          var follow = false;
          var unfollow = false;
          var cyclic = false;
          var passive1st = false;

          if (ps_name === 'follow'){
            follow = true;
          }else if (ps_name === 'unfollow'){
            unfollow = true;
          }else if (ps_name === 'cyclic_follow'){
            follow = true;
            cyclic = true;
          }else if (ps_name === 'cyclic_follow_passive1st'){
            follow = true;
            cyclic = true;
            passive1st = true;
          }else if (ps_name === 'cyclic_unfollow'){
            unfollow = true;
            cyclic = true;
          }else if (ps_name === 'cyclic_unfollow_passive1st'){
            unfollow = true;
            cyclic = true;
            passive1st = true;
          }else if (ps_name === 'unfollow_passive1st'){
            unfollow = true;
            passive1st = true;
          }

          Globs.set(KEY.FOLLOW, follow);
          Globs.set(KEY.UNFOLLOW, unfollow);
          Globs.set(KEY.CYCLIC, cyclic);
          Globs.set(KEY.UNFOLLOW_PASSIVE_1ST, passive1st);
          this.setState({follow:follow});
          this.setState({unfollow:unfollow});
          this.setState({cyclic:cyclic});
          this.setState({passive1st:passive1st});

          Globs.set(KEY.ACCOUNT_SETS_SERVER_TS, data['timestamp']);

          var validationErrors = run(this.state, fieldValidations);
          this.state.validationErrors = validationErrors;
          this.analyzeValidationErrors();
          this.setState({validationErrors:validationErrors});
       }
      },
      (error)=>{
        this.setOptionsDisabled(false);
      },
      5
      );
  }

  componentWillMount() {
    var m = moment();
    m.set({h: Globs.get(KEY.HH), m: Globs.get(KEY.MM)});
    this.setState({time_value:m});

   }

  componentDidMount() {
     this.startObtain(this.OBTAINS().ACCOUNT_SETS);

     // Run validations on initial state
    var validationErrors = run(this.state, fieldValidations);

    this.state.validationErrors = validationErrors;
    this.analyzeValidationErrors();

    this.setState({validationErrors: validationErrors});
   }

   componentWillUnmount(){
     this.cancelObtain(this.OBTAINS().ACCOUNT_SETS);
   }

   onClick(field) {
      return (e) =>
      {
        if([field]==='URL')
        {
          //console.log("value");
          e.target.value ='https://soundcloud.com/';
        }
      };
   }

  handleOnFocus(field) {
    return (e) =>
    {
      if(field==='URL')
      {
        if(e.target.value === '' || e.target.value === undefined)
        {
          e.target.value = 'https://soundcloud.com/';
          var obj = e.target;
          if (!(obj.updating))
          {
            obj.updating = true;
            var oldValue = obj.value;
            obj.value = '';
            //setTimeout(
            //  function()
              {
                obj.value = oldValue; obj.updating = false;

                //from update
                let newState = update(this.state, {
                  [field]: {$set: e.target.value}
                });

                newState.validationErrors = run(newState, fieldValidations);
                this.setState(newState);
                this.analyzeValidationErrors();
                //<-from update
              }//, 100);
          }
        }
      }
    }
  }

  isEmptyObject(obj) {
    return Object.getOwnPropertyNames(obj).length === 0;
  }

  analyzeValidationErrors(){
    if(this.isEmptyObject(this.state.validationErrors)) //no errorMessage
    {
      Globs.set(KEY.OPTIONS_ARE_CORRECT, true);
      //WSCH.001.2
      Globs.set(KEY.OPTIONS_UI_SET_TIME, moment().unix());
      //<-
    }else {

      Globs.set(KEY.OPTIONS_ARE_CORRECT, false);
    }
  }

  onLostFocus(field) {
    return (e) =>
    {
      if(field==='URL'){
        Globs.set(KEY.URL, e.target.value);
      }else if(field==='count'){
        Globs.set(KEY.COUNT, e.target.value);
      }else if(field==='follow_cnt'){
        Globs.set(KEY.FOLLOW_CNT, e.target.value);
      }else if(field==='unfollow_cnt'){
        Globs.set(KEY.UNFOLLOW_CNT, e.target.value);
      }

      this.analyzeValidationErrors();
    }
  }

  errorFor(field) {
   return this.state.validationErrors[field] || "";
  }

  controlUnfollowPassive1st(cycle,unfollow) {
   if (!(unfollow||cycle))
   {
     this.setState({unfollow_passive_1st:false});
   }
  }

  handleChange(event, entity) {
    if (this.state.disabled){
      return;
    }

    var follow = this.state.follow;
    var unfollow = this.state.unfollow;
    var cycle = this.state.cycle;
    var unfollow_passive_1st = this.state.unfollow_passive_1st;
    var follow_pros_only = this.state.follow_pros_only;
    var whitelist_manual_followings = this.state.whitelist_manual_followings;

    switch (entity.props.id)
    {
      case 'follow':
        follow = !this.state.follow;
        break;

      case 'unfollow':
        follow = this.state.unfollow;
        break;

      case 'cycle':
        cycle = !this.state.cycle;
        break;

      case 'unfollow_passive_1st':
        unfollow_passive_1st = !this.state.unfollow_passive_1st;
        break;

      case 'follow_pros_only':
        follow_pros_only = !this.state.follow_pros_only;
        break;

      case 'whitelist_manual_followings':
        whitelist_manual_followings = !this.state.whitelist_manual_followings;
        break;

      default:break;
    }

    unfollow = !follow;

    unfollow_passive_1st = (unfollow||cycle)?unfollow_passive_1st:false;
    whitelist_manual_followings = (unfollow||cycle)?whitelist_manual_followings:false;

    this.setState({follow:follow});
    this.setState({unfollow:unfollow});
    this.setState({cycle:cycle});
    this.setState({unfollow_passive_1st:unfollow_passive_1st});
    this.setState({follow_pros_only:follow_pros_only});
    this.setState({whitelist_manual_followings:whitelist_manual_followings});

    Globs.set(KEY.FOLLOW, follow);

    Globs.set(KEY.UNFOLLOW, unfollow);
    Globs.set(KEY.CYCLIC, cycle);
    Globs.set(KEY.UNFOLLOW_PASSIVE_1ST, unfollow_passive_1st);
    Globs.set(KEY.FOLLOW_PROS_ONLY, follow_pros_only);
    Globs.set(KEY.WHITELIST_MANUAL_FOLLOWINGS, whitelist_manual_followings);

    Globs.set(KEY.OPTIONS_UI_SET_TIME, moment().unix());
  }

  handleTimePickerChange = (theMoment) =>  {

    //entity.props.id
    Globs.set(KEY.HH, theMoment.hours());
    Globs.set(KEY.MM, theMoment.minutes());

    this.setState({time_value:theMoment});
  }

  handleLostFocus(field) {

  }

  handleFieldChanged(field) {
     return (e) => {
       // update() is provided by React Immutability Helpers
       // https://facebook.github.io/react/docs/update.html
       let newState = update(this.state, {
        [field]: {$set: e.target.value}
       });

       newState.validationErrors = run(newState, fieldValidations);
       this.setState(newState);
       this.analyzeValidationErrors();
      }
  }

  render() {

   return (
    <div className='panel-option component-bottom-margin'>
      <Container>
        <Row className='mb-4'>
          <Col>
            <h1>Options</h1>
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col>
            <div>
              Scrape URL: 
              <TextView placeholder="Set the URL of the user to scrape followers from." showError={this.state.showErrors}
                text={this.state.URL}
                onFieldChanged={this.handleFieldChanged("URL")}
                onFocus={this.handleOnFocus("URL")}
                onBlur={this.onLostFocus("URL")}
                onClick={this.onClick("URL")}
                errorText={this.errorFor("URL")}
                absoluteError="true"
                className="input--small"
                inline="true"
                disabled={this.state.disabled}
               />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-md-left mb-2">
          <Col xs={12} lg={4}>
            <div>
              Follow count: 
              <TextView placeholder="1-99"
                disabled={this.state.disabled || this.state.unfollow && !this.state.cycle}
                showError={this.state.showErrors}
                absoluteError="true"
                text={this.state.follow_cnt} onFieldChanged={this.handleFieldChanged("follow_cnt")}
                onFocus={this.handleOnFocus("follow_cnt")}
                onBlur={this.onLostFocus("follow_cnt")}
                errorText={this.errorFor("follow_cnt")}
                className="input--x-small"
                inline="true"
                />
            </div>
          </Col>
          <Col xs={12} lg={4}>
            <div>
              Unfollow count: 
              <TextView
                disabled={this.state.disabled || this.state.follow && !this.state.cycle}
                placeholder="1-300"
                showError={this.state.showErrors}
                absoluteError="true"
                text={this.state.unfollow_cnt} onFieldChanged={this.handleFieldChanged("unfollow_cnt")}
                onFocus={this.handleOnFocus("unfollow_cnt")}
                onBlur={this.onLostFocus("unfollow_cnt")}
                errorText={this.errorFor("unfollow_cnt")}
                className="input--x-small"
                inline="true"
              />
            </div>
          </Col>
        </Row>
        <Row className="justify-content-md-left mb-2">
         <Col xs={12} lg={4}>
           <Checkbox id="follow" caption="Follow"
            onChange={this.handleChange}
            checked={this.state.follow}
            disabled={this.state.disabled}
           />

          <Checkbox id="unfollow" caption="Unfollow"
              onChange={this.handleChange}
              checked={this.state.unfollow}
              disabled={this.state.disabled}
           />
         </Col>

         <Col xs={12} lg={8}>
          <Checkbox id="cycle" caption="Cycle"
              onChange={this.handleChange}
              checked={this.state.cycle}
              disabled={this.state.disabled}
            />

          <Checkbox id="unfollow_passive_1st" caption="1st unfollow passive followings"
            onChange={this.handleChange}
            checked={this.state.unfollow_passive_1st}
            disabled={this.state.disabled}
          />
         </Col>
       </Row>
        <Row className='mb-4'>
          <Col style={{ display: 'flex' }}>
            <Checkbox
                onChange={this.handleChange}
                disabled={this.state.disabled}
                id="schedule_on" class="start_now_Schedule" caption="Schedule daily (un)following on:" />
            <TimePicker focusOnOpen={true} disabled={this.state.disabled} value={this.state.time_value} defaultValue={this.state.time_value} showSecond={false} allowEmpty={false} onChange={this.handleTimePickerChange} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={4}>
            <Checkbox id="follow_pros_only" caption="Only follow PRO users"
            onChange={this.handleChange}
            checked={this.state.follow_pros_only}
            disabled={this.state.disabled}
            />
          </Col>
          <Col xs={12} lg={4}>
            <Checkbox id="whitelist_manual_followings" caption="Whitelist manual followings"
            onChange={this.handleChange}
            checked={this.state.whitelist_manual_followings}
            disabled={this.state.disabled}
            />
          </Col>
        </Row>
      </Container>
     </div>
   )
  }




}
